import React from "react";
import { Node_Type } from "./../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
const Anchor = React.memo(({ anchorKey, type }) => (
  // oxlint-disable-next-line @typescript-oxlint/ban-ts-comment
  // @ts-ignore
  /* @__PURE__ */ React.createElement("div", { key: anchorKey, type, "data-hook": anchorKey })
));
const isEmptyRichTextNode = (node) => [Node_Type.PARAGRAPH, Node_Type.HEADING, Node_Type.BLOCKQUOTE, Node_Type.CODE_BLOCK].includes(
  node.type
) && !node.nodes?.length;
const getAnchor = (node, nodeIndex, addAnchorsPrefix) => {
  const anchorType = isEmptyRichTextNode(node) ? "empty-line" : node.type.toLowerCase();
  const anchorKey = `${addAnchorsPrefix}${nodeIndex + 1}`;
  return /* @__PURE__ */ React.createElement(Anchor, { key: anchorKey, type: anchorType, anchorKey });
};
export {
  Anchor,
  getAnchor
};
//# sourceMappingURL=anchor.js.map
